import script from "./TextWithEllipsis.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextWithEllipsis.vue?vue&type=script&setup=true&lang=ts"

import "./TextWithEllipsis.vue?vue&type=style&index=0&id=117d10b5&scoped=true&lang=css"

import exportComponent from "/Users/yangxu/work/js_celue-zuhe_src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-117d10b5"]])

export default __exports__